export const URGENT = "TASKPRIORITY_URGENT";
export const IMPORTANT = "TASKPRIORITY_IMPORTANT";
export const MEDIUM = "TASKPRIORITY_MEDIUM";
export const LOW = "TASKPRIORITY_LOW";
